import { create } from "zustand";

interface HookProps {
  open: boolean;
  emp: {
    id: string;
    prevBool: boolean;
  } | null;
  setEmpId: (
    id: {
      id: string;
      prevBool: boolean;
    } | null
  ) => void;
  onOpenChange: (open: boolean) => void;
}

export const useEmpBlockModal = create<HookProps>()((set) => ({
  open: false,
  emp: null,
  setEmpId: (empData) =>
    set(() => ({
      emp: empData,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
